(function () {
  function initDesktop(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-sdn-item]'));
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function close(it, focus) {
      var b = it.querySelector('.sdn__trigger');
      b.setAttribute('aria-expanded', 'false');
      it.querySelector('.sdn__panel').hidden = true;
      if (focus) b.focus();
    }
    function open(it) {
      items.forEach(function (o) { if (o !== it) close(o); });
      it.querySelector('.sdn__trigger').setAttribute('aria-expanded', 'true');
      it.querySelector('.sdn__panel').hidden = false;
    }
    nav._sdnOpen = open;
    items.forEach(function (it) {
      var b = it.querySelector('.sdn__trigger');
      var t;
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-expanded') === 'true') close(it); else open(it);
      });
      if (fine) {
        it.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { open(it); }, 90); });
        it.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { close(it); }, 200); });
      }
      it.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(it, true); });
      it.addEventListener('focusout', function (e) { if (e.relatedTarget && !it.contains(e.relatedTarget)) close(it); });
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) items.forEach(function (it) { close(it); });
    });
    var jobs = Array.prototype.slice.call(nav.querySelectorAll('[data-sdn-job]'));
    function pick(j) {
      jobs.forEach(function (x) {
        var on = x === j;
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
        var a = document.getElementById(x.getAttribute('aria-controls'));
        if (a) a.hidden = !on;
      });
    }
    nav._sdnPick = pick;
    jobs.forEach(function (j) {
      j.addEventListener('click', function () { pick(j); });
      j.addEventListener('focus', function () { pick(j); });
      if (fine) j.addEventListener('mouseenter', function () { pick(j); });
    });
  }

  function initMobile(m) {
    if (m.dataset.ready) return;
    m.dataset.ready = '1';
    var ob = m.querySelector('.sdm__open');
    var pn = m.querySelector('.sdm__panel');
    var bd = m.querySelector('.sdm__backdrop');
    var timer;
    function focusables() {
      return Array.prototype.slice.call(pn.querySelectorAll('a[href], button, input, summary')).filter(function (el) { return el.offsetParent !== null; });
    }
    function openD() {
      clearTimeout(timer);
      pn.hidden = false;
      bd.hidden = false;
      ob.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { pn.classList.add('is-open'); }); });
      var c = pn.querySelector('.sdm__close');
      if (c) c.focus();
    }
    function closeD() {
      pn.classList.remove('is-open');
      ob.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      bd.hidden = true;
      timer = setTimeout(function () { pn.hidden = true; }, 260);
      ob.focus();
    }
    ob.addEventListener('click', openD);
    Array.prototype.forEach.call(m.querySelectorAll('[data-sdm-close]'), function (x) { x.addEventListener('click', closeD); });
    pn.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeD(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1200 && !pn.hidden) closeD();
    });
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-sdn]'), initDesktop);
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-sdm]'), initMobile);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var nav = el.closest && el.closest('[data-sdn]');
    if (!nav || !nav._sdnOpen) return;
    var it = el.closest('[data-sdn-item]');
    if (it) nav._sdnOpen(it);
    var job = el.matches('[data-sdn-job]') ? el : null;
    if (job && nav._sdnPick) nav._sdnPick(job);
  });
})();